import Vue from "vue";
import VueRouter from "vue-router";
import auth from "../packages/auth";
import { AppRoutes } from "./app";
import { ModuleRoutes } from "../modules/routes";
Vue.use(VueRouter);

const routes = [...AppRoutes, ...ModuleRoutes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.isAuthenticated()) {
      next({
        name: "auth.login"
      });
    } else {
      next(); // make sure to always call next()!
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
